import { IAuthRoleModel } from '@common/models/Security/AuthRoleModel';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    role: IAuthRoleModel | undefined;
    onSubmit: (role: IAuthRoleModel) => void;
    onCancel: () => void;
}

export const UserProfileRolesModalDelete = ({ role, onSubmit, onCancel }: IProps) => {
    return (
        <>
            {role &&
                <Modal centered className="confirm-dialog" show={true} onHide={onCancel} data-testid="delete-role-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Remove Role?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to remove <strong>{role.description}</strong> from this user? This user will no longer be able to perform the actions allowed by this role.</p>
                    </Modal.Body>
                    <Modal.Footer className="container-fluid">
                        <Button
                            aria-label="cancel"
                            variant="light"
                            className='cancel'
                            onClick={onCancel}>Cancel</Button>
                        <Button
                            aria-label="submit"
                            variant="primary"
                            className='confirm'
                            onClick={() => onSubmit(role)}>Remove Role</Button>
                    </Modal.Footer>
                </Modal>
            }
        </>)
};
